import tplLoader from "./tpl-loader.js";
import functions from './functions.js';
import Slider from "./Slider";
import calendar from  './calendar.js';
import {SimpleGuests} from "./simple-guests.js";

$(() => {
    details.init();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '2,0', 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    inquiryRequired: ['dates', 'firstName', 'lastName', 'email', 'phone', 'guests'],
    focusOnBooking: false,
    init() {
        if(! $('.page-type-details')[0]) {
            return;
        }
        let isMobile = true;
        
        if (isMobile)
        {
            // $('.nav-bottom').addClass('visible');
            
            $('.btn-select-date').on('click', function() {
                setTimeout(() => {
                    $('.contact-select-mobile').addClass('d-none');
                    $('.show-on-calendar').removeClass('d-none');
                }, 300);
            });
            
            $('.book-now-nav-bottom').on('click', function() {
                let wh = $(window).outerHeight();
                functions.scrollToElement($('.booking-scroll-hook'), wh);
            });
           

            // $(window).scroll(e => {


            //     $(window).scrollTop() > 200 
            //         ? $('.nav-top').addClass('visible') 
            //         : $('.nav-top').removeClass('visible');
    
            //     var elementTop = $('.booking-guests').offset().top;
            //     var elementBottom = elementTop + $('.booking-guests').outerHeight();

            //     let $bookElem = $('.btn-booking'); 

            //     if (! $bookElem.offset().top)
            //     {
            //         $bookElem = $('.calc-message');
            //     }
            //     var bookTop = $bookElem.offset().top;
                
            //     var bookBottom = bookTop + $bookElem.outerHeight();
            //     var offset = bookBottom - elementBottom + 5;

            //     var viewportTop = $(window).scrollTop();
            //     var viewportBottom = viewportTop + $(window).height();

            //     var calendarInViewport = elementBottom > viewportTop - offset && elementTop < viewportBottom;

            //     if (! calendarInViewport && viewportTop > 200)
            //     {
            //         $('.nav-bottom').addClass('visible');
            //     }
            //     else 
            //     {     
            //         $('.nav-bottom').removeClass('visible');

            //     }
    
            // });

        }
        $(window).scroll(e => {
            const offset = $('#booking').offset().top - $('#booking').outerHeight();

            $(window).scrollTop() > 200 && $(window).scrollTop() < offset
                ? $('.nav-top').addClass('visible') 
                : $('.nav-top').removeClass('visible');
        

        });

        // new Slider('#gallery-section', {
        //     rubberband: false,
        //     loop: true,
        //     arrows: true,
        //     slides: {
        //         perView: 2,
        //         spacing: 4
        //     },
        //     duration: 1000,
        //     //autoplay: 3000,
        //     autoplay: 0,
        //     pauseOnHover: true,
        //     pager: true,
        //     breakpoints: {
        //         '(max-width: 1000px)': {
        //             slides: {
        //                 perView: 1
        //             },
        //         },
        //     },
        //     autoLoadSlides: 3,
        // });

        details.getParams();
        if (isMobile && details.datesSelected())
        {
            $('.select-dates-nav-bottom').addClass('d-none');
            $('.book-now-nav-bottom').removeClass('d-none');
        }

        // if(details.params.calendar) functions.scrollToElement($('#booking'), 0);

        // let params = functions.getUrlData(true);
        // details.params.guests = params.guests;

        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');
        details.params.unitId = $('#booking').attr('data-unitid');
        details.params.objectId = $('#booking').attr('data-objectid');

        //details.splitCalendarDates($('[name=dates]').val());

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        if($('[data-calendarconfig]')[0]) {
            details.calendarInit();
        }

        let $unitForm = $('.unit-search-form');
        if($unitForm.length)
        {
            $unitForm.on('submit', e => {
                e.preventDefault();
                details.getCalculation();
            })
        }

        if(details.params.dateFrom && details.params.dateTo) {
            if($('[name="dates"]')[0]._flatpickr) {

                $('[name="dates"]')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            }
           details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        }

        if(details.params.guests && $('.simple-guests')[0]) {
            $('.simple-guests').each( (index, elem) => {
                elem._simpleGuests.setValue(details.params.guests);
            });
        }
        details.getCalculation();

        $('[name="dates"]').on('change', e => {
            
            e.preventDefault();
            const $target = $(e.target);
            details.splitCalendarDates($target.val());
            if (details.params.dateFrom && details.params.dateTo) 
            {
                details.focusOnBooking = true;
                $('.nav-bottom').removeClass('visible');
                $('.select-dates-nav-bottom').addClass('d-none');
                $('.book-now-nav-bottom').removeClass('d-none');
            }
            functions.setUrlData(details.params, true, true);
        });

        const $map = $('.od-map');
        if ($map.length) {
            let map;
            let mapTimeout;
            // check if in viewport
            if ($map[0].getBoundingClientRect) {
                $(window).on('load, scroll', e => {
                    if (map) {
                        return;
                    }
                    clearTimeout(mapTimeout);
                    mapTimeout = setTimeout(() => {
                        let screenHeight = document.documentElement.clientHeight;
                        let mapBounds = $map[0].getBoundingClientRect();
                        if (screenHeight > mapBounds.top && mapBounds.bottom > 0) {
                            window.loadGoogleMaps();
                        }
                    }, 0);
                });
            } else {
                $(window).on('load', e => window.loadGoogleMaps());
            }
            // map init
            $(window).on('gMapsLoaded', e => {
                let center;
                let isMarker;
                try {
                    center = JSON.parse($map.attr('data-lat-lng'));
                    isMarker = JSON.parse($map.attr('data-marker'));
                } catch (e) { }

                if (center) {
                    map = new google.maps.Map($map[0], {
                        center: center,
                        zoom: 12
                    });
                    if (isMarker) {
                        new google.maps.Marker({
                            map: map,
                            position: center
                        });
                    } else {
                        new google.maps.Circle({
                            map: map,
                            center: center,
                            radius: 600, // 10 miles in metres
                            fillColor: '#1B2452',
                            strokeOpacity: 0.8
                        });
                    }
                }
            });
        }

        $('.btn-clear-dates').on('click', function (e) {
            if (! (details.params.dateTo && details.params.dateFrom)) return;
            
            $('.calendar-selection').find('.selection-bg').addClass('opacity-0');
            $('.unit-calc').addClass('opacity-0')
            $('.calc-loader').prepend(tplLoader).scrollTop(0);
            $('.calc-wrapper').css('opacity', 0);
            $('.calc-wrapper').css('display', 'none');

            // debugger;
            $('[name="dates"]')[0]._flatpickr.setDate([]);
            details.params.dateTo = details.params.dateFrom = null;
            functions.setUrlData(details.params, true, true);

            details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);

            $('.text-total').addClass('d-none');
            $('.text-from').removeClass('d-none');

            $('.price').removeClass('d-none');
            $('.price-calculated').addClass('d-none');

            if ( ! $.trim($('.price-old').html()) ) $('.price-old').addClass('d-none');
            else $('.price-old').removeClass('d-none')
            
            $('.price-old-calculated').addClass('d-none');
            $('.price-old-wrap').removeClass('d-none');

            $('.price-old-converted').removeClass('d-none');
            $('.price-old-converted-calculated').addClass('d-none');

            $('.price-converted').removeClass('d-none');
            $('.price-converted-calculated').addClass('d-none');


            setTimeout(() => {
                $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                $('.calc-wrapper').css('opacity', 1);
                $('.calc-wrapper').css('display', 'flex');
                $('.calendar-selection').find('.selection-bg').removeClass('opacity-0');
                $('.unit-calc').removeClass('opacity-0');
             
            }, 450)

        });

        $('[name="guests"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.guests = $target.val();
            functions.setUrlData(details.params, true, true);
        });

        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });
        
        details.loadReviews();
        details.inquiryInit();

    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 4;
            let page = +$button.data('page') + 1;
            let total = Math.round(+$button.data('total') / perPage);

            $.post('/services/reviews/', { language : functions.getLang(), perPage : perPage, page: page, objectId: $button.data('objectid') }).then(response => {
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= page) {
                        $button.addClass('d-none');
                    }
                    $(".reviews").append(response.html);
                }
            });
        });
    },
    calendarInit() {
        let config = JSON.parse($('[data-calendarconfig]').attr('data-calendarconfig'));

        let defaultDate = $('[data-calendarconfig][data-defaultdate]').attr('data-defaultdate');
        let minDate = $('[data-calendarconfig]').attr('data-mindate') || 'today';
        /*if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }*/
        calendar.calendar.init(
            $('.datepicker-range-book'),
            {
                availabilityMask : config.availabilityMask,
                minStay : config.minStay,
                periods : config.periods,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate,
                mode: 'range',
                inline: true,
                containerClass : 'details-booking-calendar'
            },
            details.callbackOnDatesSelected
        );
    },
    inquiryInit() {
        $('form#inquiry').find('#request-name, #request-surname, #request-email, #request-tel, #request-addres, .request-dates.input').focusout( function(e) {
            let $elem = $(this);
            let valid = true;
            
            if ($elem.attr('name') == 'email')
            {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                valid = regex.test($elem.val());
            }

            if ($elem.hasClass('request-dates'))
            {
                $elem = $('#request-dates');
            }

            if ( ! ($elem.val() && valid)) 
            {
                // validForm = false;
                $elem.addClass('input-empty');
                $elem.siblings('.invalid-feedback').addClass('d-block');
            }
            else
            {
                $elem.removeClass('input-empty');
                $elem.siblings('.invalid-feedback').removeClass('d-block');
            }
        })
        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            let allParams = $(e.currentTarget).serializeArray();
            
            $.each(allParams, function (i, field) {
                params[field.name] = field.value;
            });

            if (params.datesi) 
            {
                params.dates = params.datesi;
                delete params.datesi;
            }
            
            let validForm = true;
            $('form#inquiry').find('#request-name, #request-surname, #request-email, #request-tel, #request-addres, .request-dates.input').each( function(e) {
                let $elem = $(this);
                let valid = true;
                // if ($elem.attr('name') ==)
                if ($elem.attr('name') == 'email')
                {
                    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    valid = regex.test($elem.val());
                }
    
                if ( ! ($elem.val() && valid)) 
                {
                    validForm = false;
                    $elem.addClass('input-empty');
                    $elem.siblings('.invalid-feedback').addClass('d-block');
                }
                else
                {
                    $elem.removeClass('input-empty');
                    $elem.siblings('.invalid-feedback').removeClass('d-block');
                }
            })
            if (! validForm)
            {   
                $('.contact-btn').removeClass('d-none');
                $('.contact-spinner').addClass('d-none');
                $('.contact-spinner').removeClass('d-flex');
                return;
            }
            
            functions.setFormData($('form#inquiry'), params);
            params['language'] = functions.getLang();
            
            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            grecaptcha.ready(function () {
                grecaptcha.execute('6LdtqLwUAAAAAO-PrV_Cd-Ih9FrupyYbk8No6sus', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {
                        $("#inquiry").addClass('d-none');
                        response.status ? $('.request-success').html(response.data).removeClass('d-none') : $('.request-error').html(response.data).removeClass('d-none');
                        setTimeout(() => {
                            $('.request-modal-close').click();
                            $('.contact-btn').removeClass('d-none');
                            $('.contact-spinner').addClass('d-none');
                            $('.contact-spinner').removeClass('d-flex');
                            $("#inquiry").removeClass('d-none');
                            $(".request-error, .request-success").addClass('d-none');
                        }, 7000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }


                    });
                });
            });
        });
    },
    callbackOnDatesSelected(from, to) {

        if ( to && ! to[1]) {
            $('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({type : 'selectDates'}));
            $('.btn-booking').addClass('disabled');
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    isRequest(data) {
        return ! data.isAvailable && data.calc.status == 'Request';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    datesSelected()
    {
        return details.params.dateFrom && details.params.dateTo;
    },
    getCalculation(unitId = null) {


        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;
        unitId = details.params.unitId;
        
        if(
            (details.params.objectId || unitId)
            && details.params.guests 
            && dateFrom 
            && dateTo 
            && details.params.objectGroupId
        ) {

            $('.calendar-selection').find('.selection-bg').addClass('opacity-0');
            $('.unit-calc').addClass('opacity-0')
            $('.calc-loader').prepend(tplLoader).scrollTop(0);
            $('.calc-wrapper').css('opacity', 0);
            $('.calc-wrapper').css('display', 'none');

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang() 
                + '&addAllOptionals=' + 1
            )
            .done(response => {

                if(response.status) {
                    const data = response.data || [];

                    Object.entries(data).forEach(unit => {
                        const unitId = unit[0];
                        const unitData = unit[1];
                        const $unit = $('.unit-card[data-unitid=' + unitId + ']');
                        const $btnBooking = $unit.find('.btn-booking');
                        if(details.isBookable(unitData)) {

                            $btnBooking.removeClass('disabled');

                            const unitCalc = unitData.calc;

                            const calcItems = unitCalc.items;
                            let priceOld = 0.00;
                            let priceOldEUR = 0.00;
                            let discountTitle = null;

                            calcItems.forEach(item => {
                                // popust za djecu ne ulazi u prikaz discount cijene
                                if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                    priceOld += item.itemTotal;
                                    priceOldEUR += item.itemTotalEUR;
                                }
                                if(item.itemType == 'discount') {
                                    discountTitle = item.itemTitle;
                                    if(item.data && item.data.text) {
                                        discountTitle = item.data.text;
                                    }
                                }
                            });

                            const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                            const priceOldFormated  = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');
                            const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',')  + ' kn';
                            const priceOldEURFormated = functions.formatMoney(priceOldEUR, 0, '.', ',') + ' kn';

                            if($btnBooking.attr('href')) {
                                $btnBooking.attr('href',
                                    $btnBooking.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '&dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&guests=' + details.params.guests +
                                    '&addAllOptionals=' + 1
                                );
                            }
                            let guestsText = unitCalc.guests.split(',', 2);
                            guestsText = guestsText.reduce((sum, num) => sum + +num, 0);

                            let $convertedElem = $unit.find('.price-converted');

                            $unit.find('.calc-message').addClass('d-none')
                            $unit.find('.text-total').removeClass('d-none');
                            $unit.find('.text-from').addClass('d-none');

                            if ($convertedElem.length)
                            {
                                $unit.find('.price-converted').addClass('d-none');
                                $unit.find('.price-converted-calculated').text(totalEUR).removeClass('d-none');
                            }


                            $unit.find('.price').addClass('d-none');
                            $unit.find('.price-calculated').text(total).removeClass('d-none');

                            $unit.find('.price-old').addClass('d-none');
                            $unit.find('.price-old-calculated').addClass('d-none');
                            if (priceOld > unitCalc.total) 
                            { 
                                $unit.find('.price-old-wrap').removeClass('d-none');
                                $unit.find('.price-old-calculated').text(priceOldFormated).removeClass('d-none');

                                if ($convertedElem.length)
                                {
                                    $unit.find('.price-old-converted').addClass('d-none');
                                    $unit.find('.price-old-converted-calculated').text(priceOldEURFormated).removeClass('d-none');
                                }
                            }
                            else 
                            { 
                                $unit.find('.price-old-wrap').addClass('d-none'); 
                                $unit.find('.price-old-converted').addClass('d-none');
                                $unit.find('.price-old-converted-calculated').addClass('d-none');
                            }  

                        } else 
                        {
                            $btnBooking.addClass('disabled');
                            $unit.find('.text-total').addClass('d-none');
                            $unit.find('.text-from').addClass('d-none');

                            $unit.find('.price').addClass('d-none');
                            $unit.find('.price-calculated').addClass('d-none');

                            $unit.find('.price-old').addClass('d-none');
                            $unit.find('.price-old-calculated').addClass('d-none');
                            $unit.find('.price-old-wrap').addClass('d-none'); 

                            $unit.find('.price-old-converted').addClass('d-none');
                            $unit.find('.price-old-converted-calculated').addClass('d-none');

                            $unit.find('.price-converted').addClass('d-none');
                            $unit.find('.price-converted-calculated').addClass('d-none');

                            $unit.find('.calc-message').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                        }
                       

                    });

                     setTimeout(() => {
                            let wh = $(window).outerHeight();
                            $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                            $('.calc-wrapper').css('opacity', 1);
                            $('.calc-wrapper').css('display', 'flex');
                            $('.calendar-selection').find('.selection-bg').removeClass('opacity-0');
                            $('.unit-calc').removeClass('opacity-0');
                         
                        }, 450)
                }


            }).fail(function (error) {
            });
        }

        else {
            $('.btn-booking').addClass('disabled');
            $('.no-calculation').removeClass('d-none');
            $('.calculation').addClass('d-none');
            $('.btn-select-dates').removeClass('d-none');

            $('.calc-message').addClass('d-none');
            $('.unit-price-container').removeClass('d-none');

            $('.total-old').toggleClass('d-none', ! $('.total-old').attr('data-minPriceHasDiscount'));
            $('.total-old').text($('.total-old').attr('data-minPriceHasDiscount') ? $('.total-old').attr('data-minPriceOld') : '');

        }
    }
}